import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Team from '@/plugins/sdk/resources/Team'
import Role from '@/plugins/sdk/resources/Role'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'profileroleteam'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      team: new ITEM(Team),
      profile: new ITEM(Profile),
      role: new ITEM(Role)
    }
  }
}
